import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import {pendingUpdatesSingleton} from '../../state-providers/data-refresh/pending-updates'
import {type BulkUpdateMemexItemsRequest, type BulkUpdateMemexItemsResponse, REQUEST_ID_HEADER} from './contracts'

export async function apiBulkUpdateItems(body: BulkUpdateMemexItemsRequest): Promise<BulkUpdateMemexItemsResponse> {
  pendingUpdatesSingleton.increment()

  try {
    const apiData = getApiMetadata('memex-item-update-bulk-api-data')
    const {headers: responseHeaders, data} = await fetchJSONWith<BulkUpdateMemexItemsResponse>(apiData.url, {
      method: 'PUT',
      body,
    })
    // This update is handled asynchronously.
    // See live-update.tsx where the BulkUpdateCompleteSocketMessageData is processed.

    const requestId = responseHeaders.get(REQUEST_ID_HEADER) || undefined

    return {requestId, ...data}
  } catch (e) {
    pendingUpdatesSingleton.decrement()
    throw e
  }
}
